module.exports = __webpack_public_path__ + "img/wechat_oauth2.fe4971b3.png";